import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRegisteredGate from './routes/AppRegisteredGate';
import LoginLux from './pages/LoginLux';
import RegisterLux from './pages/RegisterLuxForm';
import { appCopy } from './pages/appCopy';
import HomeLuxWhiteGold from './pages/HomeLuxWhiteGold';
import Dashboard from './pages/Dashboard';
import AuctionListLux from './pages/AuctionListLux';
import AuctionSimulationLux from './pages/AuctionSimulationLux';
import AuctionDetailLux from './pages/AuctionDetailLux';
import AdminDashboard from './pages/AdminDashboard';
import AdminRoute from './routes/AdminRoute';
import AdminRouteEn from './routes/AdminRouteEn';
import LabRoute from './routes/LabRoute';
import useTracker from './hooks/useTracker';
import { setTracker } from './trackerBus';
import CompleteProfileModal from './components/CompleteProfileModal';
import DynamicSurveyModal from './components/DynamicSurveyModal';
import PromoSurveyModal from './components/PromoSurveyModalLab';
import LeilaoSurveyModal from './components/LeilaoSurveyModal';
import ClientGuideModal from './components/ClientGuideModal';
import Gate from './pages/Gate';
import config from './config';
import { isSisterStore, htmlLang, storeTitle } from './sisterStore';

const RegisterLuxEn = React.lazy(() => import('./pages/RegisterLuxEn'));
const AuctionListLuxEn = React.lazy(() => import('./pages/AuctionListLuxEn'));
const PointsAndReferralEn = React.lazy(() => import('./pages/PointsAndReferralEn'));
const PrizeWheel = React.lazy(() => import('./pages/PrizeWheel'));
const PointsAndReferral = React.lazy(() => import('./pages/PointsAndReferral'));
const News = React.lazy(() => import('./pages/News'));
const SuperPromos = React.lazy(() => import('./pages/SuperPromos'));
const LabStorefront = React.lazy(() => import('./lab/LabStorefront'));
const ShopEn = React.lazy(() => import('./lab/ShopEn'));
const DashboardSister = React.lazy(() => import('./pages/DashboardSister'));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', background: '#1a1a1a',
          color: '#fff', fontFamily: 'sans-serif', padding: 24, textAlign: 'center'
        }}>
          <h1 style={{ fontSize: 24, marginBottom: 12, color: '#D4AF37' }}>{appCopy(config.STORE_LOCALE).oops}</h1>
          <p style={{ color: '#aaa', marginBottom: 24 }}>{appCopy(config.STORE_LOCALE).oopsBody}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 32px', background: 'linear-gradient(135deg, #D4AF37, #8B6914)',
              color: '#fff', border: 'none', borderRadius: 12, fontSize: 16, cursor: 'pointer'
            }}
          >
            {appCopy(config.STORE_LOCALE).reload}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function LoadingFallback() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#1a1a1a'
    }}>
      <div style={{
        width: 40, height: 40, border: '3px solid rgba(212,175,55,0.2)',
        borderTopColor: '#D4AF37', borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

function NotFound() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: '#1a1a1a',
      color: '#fff', fontFamily: 'sans-serif', padding: 24, textAlign: 'center'
    }}>
      <h1 style={{ fontSize: 72, margin: 0, color: '#D4AF37' }}>404</h1>
      <p style={{ fontSize: 18, color: '#aaa', marginBottom: 24 }}>{appCopy(config.STORE_LOCALE).notFound}</p>
      <Link
        to="/home"
        style={{
          padding: '12px 32px', background: 'linear-gradient(135deg, #D4AF37, #8B6914)',
          color: '#fff', border: 'none', borderRadius: 12, fontSize: 16,
          textDecoration: 'none', display: 'inline-block'
        }}
      >
        {appCopy(config.STORE_LOCALE).backHome}
      </Link>
    </div>
  );
}

function StorefrontRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="*" element={<ShopEn />} />
      </Routes>
    </Suspense>
  );
}

function TrackedRoutes() {
  const { trackEvent } = useTracker();
  React.useEffect(() => {
    setTracker(trackEvent);
    return () => setTracker(() => {});
  }, [trackEvent]);
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route exact path="/" element={<LoginLux />} />
        {config.GATE_ENABLED ? <Route exact path="/gate" element={<Gate />} /> : null}
        {config.LAB_ENABLED ? <Route exact path="/lab" element={<LabStorefront />} /> : null}
        {(config.LAB_ENABLED || isSisterStore()) ? <Route exact path="/shop" element={<ShopEn />} /> : null}
        <Route exact path="/register" element={isSisterStore() ? <RegisterLuxEn /> : <RegisterLux />} />
        <Route element={<AppRegisteredGate />}>
          <Route exact path="/home" element={<HomeLuxWhiteGold />} />
          <Route exact path="/dashboard" element={isSisterStore() ? <DashboardSister /> : <Dashboard />} />
          <Route element={<LabRoute />}>
            <Route exact path="/auctions" element={isSisterStore() ? <AuctionListLuxEn /> : <AuctionListLux />} />
            <Route exact path="/auction/:id" element={<AuctionDetailLux />} />
            <Route exact path="/auction/simulation" element={<AuctionSimulationLux />} />
          </Route>
          <Route element={isSisterStore() ? <AdminRouteEn /> : <AdminRoute />}>
            <Route exact path="/admin" element={<AdminDashboard />} />
          </Route>
          <Route exact path="/prize-wheel" element={<PrizeWheel />} />
          <Route exact path="/points" element={isSisterStore() ? <PointsAndReferralEn /> : <PointsAndReferral />} />
          <Route exact path="/news" element={<News />} />
          <Route exact path="/super-promos" element={<SuperPromos />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  React.useEffect(() => {
    if (isSisterStore()) {
      document.documentElement.lang = htmlLang();
      document.title = storeTitle();
    }
  }, []);
  if (config.STOREFRONT_ENABLED) {
    return (
      <div className="App">
        <ErrorBoundary>
          <Router>
            <StorefrontRoutes />
          </Router>
        </ErrorBoundary>
      </div>
    );
  }
  return (
    <div className="App">
      <ErrorBoundary>
        <Router>
          <TrackedRoutes />
          <CompleteProfileModal />
          <DynamicSurveyModal />
          <PromoSurveyModal />
          <LeilaoSurveyModal />
          <ClientGuideModal />
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;
